//get CountryDisplayName for a given country code and locale, with fallback to the code itself if not found
type IntlWithDisplayNames = typeof Intl & {
    DisplayNames: new (locales: string | string[], options: { type: string }) => { of(code: string): string | undefined };
};

export const getCountryDisplayName = (code: string, locale: string): string => {
    try {
        const regionNames = new (Intl as IntlWithDisplayNames).DisplayNames([locale], { type: 'region' });
        return regionNames.of(code.toUpperCase()) ?? code;
    } catch {
        return code;
    }
};
